import { notification } from "antd";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { loadFreeFormReports, loadFullMarketReports, loadGenerateGrid, loadMarketCategoryReports, loadSingleCategoryReports } from "../../utils/report/ReportsHelper";
import { disabledAnalysisWhen, getMarketPackageCode, removeAllReport, runReports } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { isViewer } from "../../utils/MainHelper";

function useReportBuilder() {
    const [behaviouralSegmentData, setBehaviouralSegmentData] = useState(null);

    const {
        generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData, reportIsLoading, generateGrid
    } = useSelector((state) => state.reports);
    const { mode } = useSelector((state) => state.reportBuilder);

    const {
        configuration: { buildedTargets }
    } = useSelector((state) => state.marketExplorer);

    useEffect(() => {
        if (window.sq.oneintel.isLoadedAnalysis) return;
        if (isViewer()) return
        if (mode === "fullmarket") {
            loadFullMarketReports();
        } else if (mode === "singlecategory") {
            loadSingleCategoryReports();
        } else if (["marketcategory", "hcpattributes", "hcpmarketscan", "petientmarketscan",
            "tiktokhastags",
            "analysis_gdn&trv_affinity",
            "analysis_gdn&trv_purchase",
            "analysis_gdn&trv_topic",
            "yahoo_audiences_attribute_targeting",
            "yahoo_audiences_interests",
            "yahoo_audiences_purchase_intent_targeting",
            "tiktokinterest",
            "tiktokvideointeractions",
            "purchaseintentions",
            "icd10clinicalmodification",
            "icd10procedurecodingsystem",
            "tiktokcreatorinteractions",
            "la_demographicsattributes",
            "la_behavioralattributes",
            "la_purchaseintent",
            "la_hobbiesinterests",
            "medicaljournal",
            "medicalassociations",
            "medicalwebsites",
            "medicalconferences",
            "continuingmedicaleducation"].includes(mode) || (mode === "mokb_analysis" && getMarketPackageCode() !== "whitespaces")) {
            loadMarketCategoryReports(true);
        } else if (mode === "freeform") {
            loadFreeFormReports(true);
        } else if (["candidatewhitespaces",
            "analysis_politicaltaxonomy",
            "usersearchjourney",
            "otherwhitespaces",
            "claimswhitespaces",
            "ingredientshitespaces",
            "safetycocernsideeffectswhitespaces",
            "macrowhitespaces",
            "standardtreatmentjourney",
            "othermacrowhitespaces",
            "mokb_analysis",
            "symptomswhitespaces",
            "diagnosistreatmentwhitespaces"].includes(mode)) {
            loadGenerateGrid(true);
        }
    }, [mode]);

    const removeAllReportFnc = () => {
        removeAllReport();
        setBehaviouralSegmentData(null);
    };

    useEffect(() => {
        if (window.sq.oneintel.isLoadedAnalysis) return;
        if (isViewer()) return
        // Back to Analysis Selection if the builded targets are empty
        if (!buildedTargets.length) {
            removeAllReportFnc();
        } else {
            runReports();
            if (disabledAnalysisWhen()) {
                removeAllReportFnc();
            }
        }
    }, [buildedTargets]);

    useEffect(() => {
        // Back to Analysis Selection if the reports are empty
        if (!reportIsLoading
            && !categoryDeepDiveData.length
            && !generalMarketCategoriesData.length
            && !audienceSpecificCategoriesData.length
            && !generateGrid.length) {
            removeAllReportFnc();
        }
    }, [reportIsLoading,
        categoryDeepDiveData.length,
        generalMarketCategoriesData.length,
        audienceSpecificCategoriesData.length,
        generateGrid.length]);

    useEffect(() => { // show notification when generating reports
        if (reportIsLoading) {
            notification.destroy("errorNotification");
            notification.info({
                message: "Generating Report",
                description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
                duration: null,
                placement: "topRight",
                closable: true,
                // closeIcon: (<div />),
                key: "reportsnotif"
            });
        } else {
            notification.destroy("reportsnotif");
        }
    }, [reportIsLoading]);

    return {
        behaviouralSegmentData,
        setBehaviouralSegmentData
    };
}

export default useReportBuilder;
